export default function IntendedLearners({ setApplicationState, applicationPiece }) {
  
  function addStudentLearning(e, index) {
    try {
      setApplicationState(prev => {
        let arr = prev.coursePlan.intendedLearners.whatWillStudentsLearn;
        if(arr.length === 0) arr = ["", "", "", ""];
        arr[index] = e.target.value;
        const final = {...prev, coursePlan: {
          ...prev.coursePlan,
           intendedLearners: {
            ...prev.coursePlan.intendedLearners,
            whatWillStudentsLearn: arr
           }
        }}

        return final;
      })
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <h5>What will students learn in your course?</h5>
      <p>You must enter at least 4 learning objectives or outcomes that learners can expect to achieve after completing your course.</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>addStudentLearning(e, 0)} value={applicationPiece.intendedLearners.whatWillStudentsLearn[0]} placeholder="Example: Define roles & responsibilities of a project manager" type="text" maxLength={160} />
        <input onChange={(e)=>addStudentLearning(e, 1)} value={applicationPiece.intendedLearners.whatWillStudentsLearn[1]} placeholder="Example: Estimate project timelines and budgets" type="text" maxLength={160} />
        <input onChange={(e)=>addStudentLearning(e, 2)} value={applicationPiece.intendedLearners.whatWillStudentsLearn[2]} placeholder="Example: Identify and manage project risks" type="text" maxLength={160} />
        <input onChange={(e)=>addStudentLearning(e, 3)} value={applicationPiece.intendedLearners.whatWillStudentsLearn[3]} placeholder="Example: Complete a case study to manage a project from conception to completion" type="text" maxLength={160} />
      </div>
      <h5>What are the requirements or prerequisites for taking your course?</h5>
      <p>List the required skills, experience, tools or equipment learners should have prior to taking your course. If there are no requirements, use this space as an opportunity to lower the barrier for beginners.</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, intendedLearners:{ ...prev.coursePlan.intendedLearners, prerequisites: [e.target.value] }}}))}} value={applicationPiece.intendedLearners.prerequisites[0]} placeholder="Example: No programming experience needed. You will learn everything you need to know" type="text" />
      </div>
      <h5>Who is this course for?</h5>
      <p>Write a clear description of the intended learners for your course who will find your course content valuable. This will help you attract the right learners to your course.</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, intendedLearners:{ ...prev.coursePlan.intendedLearners, intendedAudience: [e.target.value] }}}))}} value={applicationPiece.intendedLearners.intendedAudience[0]} placeholder="Example: Beginner python developers curious about data science" type="text" />
      </div>
    </>
  )
}